import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import ScrollToTop from './Components/ScrollToTop';


import Home  from './Pages/Home/Home';

import About  from './Pages/About/About';
import Services  from './Pages/Service/Services';
import Portfolio from './Pages/Portfolio/Portfolio';
import Career  from './Pages/Career/Career';
import Contact  from './Pages/Contact';
import Training from './Pages/Training/Training';
import Internship from './Pages/Internship/Internship';

import AdminLogin from './Pages/Admin/AdminLogin';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import AdminPortfolio from './Pages/Admin/AdminPortfolio';
import AdminCareers from './Pages/Admin/AdminCareers';
import AdminInternships from './Pages/Admin/AdminInternships';
import ProtectedRoute from './Components/ProtectedRoute';

import Footer from './Components/Footer';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div style={{ paddingTop: '76px' }}>
       <Navbar />
        <Routes>
          <Route path="/"                 element={<Home />}            />
          <Route path="/about"            element={<About />}           />
          <Route path="/services"         element={<Services />}        />
          <Route path="/portfolio"        element={<Portfolio />}       />
          <Route path="/career"           element={<Career />}          />
          <Route path="/contact"          element={<Contact />}         />
          <Route path="/training"         element={<Training />}        />
          <Route path="/internship"       element={<Internship />}      />
          {/* <Route path="/abroad-studies" element={<AbroadAdmission />} /> */}

          <Route path="/admin" element={<AdminLogin />} />

          <Route path="/admin/trainings" element={
            <ProtectedRoute><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/admin/portfolio" element={
            <ProtectedRoute><AdminPortfolio /></ProtectedRoute>
          } />
          <Route path="/admin/careers" element={
            <ProtectedRoute><AdminCareers /></ProtectedRoute>
          } />
          <Route path="/admin/internships" element={
            <ProtectedRoute><AdminInternships /></ProtectedRoute>
          } />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;